import React from "react";

class IncludeHUI extends React.Component<{}> {
  componentDidMount() {
    import("./IncludeHUI.lazy.less");
  }

  render() {
    return null;
  }
}

export default IncludeHUI;
